import { Pipe, PipeTransform } from '@angular/core';
import { ODOO_ERROR_MESSAGE } from '../helpers/odoo-error-message';

@Pipe({
  name: 'odooErrorMessage',
  pure: false,
})
export class OdooErrorMessagePipe implements PipeTransform {

  transform(value: string): string {

    if (value == null || value.length === 0) {
      return value;
    }

    for (const key in ODOO_ERROR_MESSAGE) {
      if (value.includes(key)) {
        value = ODOO_ERROR_MESSAGE[key];
        break;
      }
    }

    return value;
  }

}
